import BaseError from '../BaseError';

class InvalidActionError extends BaseError {
  constructor(componentName, action) {
    super(`${componentName || 'Component'} cannot perform action: ${action}`);
  }
}

export default InvalidActionError;
